/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import Loading from 'app/components/common/Loading.jsx';
import PostGroupProvider from 'app/redux/Providers/PostGroupProvider.jsx';

class PostGroupControl extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            newGroup: {
                name: ''
            },
            groups: [],
            working: false,
            errors: {},
            removeGroup: 0,
            loading: true
        };

        // bind functions here
        this.newGroupAction = this.newGroupAction.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.removeGroupAction = this.removeGroupAction.bind(this);
        this.confirmRemoveGroup = this.confirmRemoveGroup.bind(this);
        this.cancelRemoveGroup = this.cancelRemoveGroup.bind(this);
        this.clearError = this.clearError.bind(this);
        this.onGroupSelect = this.onGroupSelect.bind(this);

    }

    componentDidMount() {

        this.props.getPostGroups();

    }

    componentDidUpdate(prevProps, prevState) {

        let errors = [];

        errors = this.props.getApiErrors(['POSTGROUP_UPDATE', 'POSTGROUP_CREATE', 'POSTGROUP_DELETE']);
        if (errors.length) {
            if (_.isEmpty(this.state.errors)) {
                this.setState({
                    errors: errors[0]
                });
            }
        }

        if ((prevProps.app.loading.POSTGROUP_LIST === false && this.props.app.loading.POSTGROUP_LIST === false) &&
             prevProps.postgroups.length < this.props.postgroups.length) {
            this.props.togglePostControl();
        }

        if (prevProps.app.loading.POSTGROUP_LIST === true && this.props.app.loading.POSTGROUP_LIST === false) {
            this.setState({
                loading: false
            });
        }

        if (prevState.working) {
            this.setState({
                working: false
            });
        }

    }

    onInputChange(e) {

        FormUtilityMixin.requestChange.apply(this, [e]);

    }

    newGroupAction(e) {

        if (this.state.newGroup.name.trim() === '') {
            this.setState({
                errors: {
                    name: "A space character (or three) isn't the most helpful name. Try something with letters or numbers!"
                }
            });
            return;
        }

        this.props.createPostGroup({
            name: this.state.newGroup.name,
            group: this.props.selectedSocials
        });

        this.setState({
            working: true
        });

    }

    removeGroupAction(e) {

        e.preventDefault();
        e.stopPropagation();

        if (e.currentTarget.dataset && e.currentTarget.dataset.id) {
            this.setState({
                removeGroup: parseInt(e.currentTarget.dataset.id, 10)
            });
        }

    }

    confirmRemoveGroup(e) {

        e.preventDefault();
        e.stopPropagation();

        if (e.currentTarget.dataset && e.currentTarget.dataset.id) {
            this.props.deletePostGroup(parseInt(e.currentTarget.dataset.id, 10));
            this.setState({
                working: true
            });
        }

    }

    cancelRemoveGroup(e) {

        e.preventDefault();
        e.stopPropagation();

        this.setState({
            removeGroup: 0
        });

    }

    onGroupSelect(e) {

        let socials = [],
            group = {},
            groupId = parseInt(e.currentTarget.dataset.id);

        if (groupId) {
            group = _.findWhere(this.props.postgroups, {'id': groupId});
            if (group !== undefined) {
                this.props.selectionCallback(group.group);
            }
        }
    }

    clearError(e) {

        e.preventDefault();

        this.props.deleteApiError(['POSTGROUP_CREATE', 'POSTGROUP_UPDATE', 'POSTGROUP_DELETE']);
        this.setState({
            errors: {}
        });

    }

    render() {
        let newGroupPlaceholder = 'Name your group',
            newGroupAction = this.newGroupAction,
            newGroupButtonLabel = 'Add',
            newGroupButtonClass = 'new-post-group-button',
            fieldInactive = '',
            groupList = null,
            closeButton = (
                <div className="close-post-group-control" onClick={this.props.togglePostControl} role="button" aria-label="close post groups">
                    <i className="icon ion-close-round"></i>
                </div>
            );

        if (this.props.selectedSocials.length === 0) {
            newGroupAction = this.props.togglePostControl;
            newGroupButtonLabel = 'Choose';
            newGroupButtonClass += ' inactive';
            newGroupPlaceholder = 'Select socials for a new group';
            fieldInactive = true;
        }

        if (this.state.loading) {
            groupList = (
                <div className="empty-group-list">
                    <div className="post-group-list-header">Post Groups Loading{closeButton}</div>
                    <Loading/>
                </div>
            );
        } else if (Object.keys(this.state.errors).length > 0) {
            groupList = (
                <div className="empty-group-list">
                    <div className="post-group-list-header error">{"Oh no! Something went wrong."}{closeButton}</div>
                    {Object.keys(this.state.errors).map((key) => {
                        return (
                            <p key={"error-" + key} className="error">{this.state.errors[key]}</p>
                        );
                    })}
                    <p className="error ack">
                        <a href="#" onClick={this.clearError} className="post-group-error-ack">OK!</a>
                    </p>
                </div>
            );
        } else if (this.props.postgroups.length === 0) {
            groupList = (
                <div className="empty-group-list">
                    <div className="post-group-list-header">Create a Post Group!{closeButton}</div>
                    <p>Just click a few socials in the posting tool, then give that group a name below. Presto!</p>
                    <p>Next time you want to post to that group, just select that group.</p>
                </div>
            );
        } else {
            groupList = (
                <div>
                    <div className="post-group-list-header">Choose an existing group{closeButton}</div>
                    <ul className="post-group-list-wrapper">
                        {this.props.postgroups.map((groupItem) => {
                            let removeControls = null;

                            if (this.state.removeGroup === groupItem.id) {
                                removeControls = (
                                    <div className="group-controls">
                                        <i className="cancel-group-delete icon ion-arrow-left-c" onClick={this.cancelRemoveGroup} data-id={groupItem.id} role='button' aria-label="cancel"></i>
                                        <i className="icon ion-trash-a" onClick={this.confirmRemoveGroup} data-id={groupItem.id} role='button' aria-label="confirm"></i>
                                    </div>
                                );
                            } else {
                                removeControls = (
                                    <div className="group-controls">
                                        <i className="icon ion-close-round" onClick={this.removeGroupAction} data-id={groupItem.id} role="button" aria-label="remove"></i>
                                    </div>
                                );
                            }

                            return (
                                <li className="post-group-list-item" onClick={this.onGroupSelect} data-id={groupItem.id} key={groupItem.id} role="button" aria-label='select group'>
                                    <div className="group-wrapper">
                                        <div className="group-name">
                                            {groupItem.name}
                                        </div>
                                        {removeControls}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        }

        if (this.state.working) {
            newGroupButtonLabel = (<i className="fa fa-circle-o-notch fa-spin"></i>);
            newGroupAction = null;
        }

        return (
            <div className="post-group-control-wrapper">
                <div className="post-group-control">
                    <div className="post-group-list">
                        {groupList}
                    </div>
                    <div className="new-post-group-controls">
                        <input type="text" disabled={fieldInactive} className="new-post-group-name" placeholder={newGroupPlaceholder} value={this.state.newGroup.name} onChange={this.onInputChange} data-field="newGroup.name"/>
                        <button className={newGroupButtonClass} onClick={newGroupAction}>
                            {newGroupButtonLabel}
                        </button>
                    </div>
                </div>
            </div>
        );

    }

};

PostGroupControl.displayName = "PostGroupControl";

PostGroupControl.propTypes = {
    selectedSocials: PropTypes.array,
    selectionCallback: PropTypes.func,
    togglePostControl: PropTypes.func
};

PostGroupControl.defaultProps = {
    selectedSocials: [],
    selectionCallback: null,
    togglePostControl: null
};

export default PostGroupProvider(PostGroupControl);
